customElements.get('product-form') ||
  customElements.define(
    'product-form',
    class extends HTMLElement {
      constructor() {
        super(),
        this.form = this.querySelector('form')
        this.variantId = this.getAttribute('data-variant')
        this.sectionId = this.getAttribute('data-section')
        this.cartUI = document.querySelector('cart-drawer') || document.querySelector('cart-items')
        this.gwpAttribute = this.dataset.gwpGift
        this.umgGwp = window.UmgGwp

        if (this.gwpAttribute !== undefined) {
          disableFormIfGwp()
        }

        if (this && this.getAttribute('data-enable-sticky-atc') === 'true') {
          this.handleStickyAtc();
        }

        function disableFormIfGwp() {
          const gwpProductForm = this
          if (gwpProductForm !== undefined) {
            gwpProductForm.remove()
          }
        }

        this.quantitySpinner = document.querySelector('quantity-input[data-variant-id="' + this.variantId + '"][data-section="' + this.sectionId + '"]'),
        this.submitButtons = this.querySelectorAll('button[type=submit]')
        this.querySelector('form')
          ? ((this.form = this.querySelector('form')),
          (this.form.querySelector('[name=id]').disabled = false),
          this.form.addEventListener(
            'submit',
            this.onSubmitHandler.bind(this)
          ))
          : ((this.querySelector('[name=id]').disabled = false),
          this.querySelector('button[type=submit]').addEventListener(
            'click',
            this.onSubmitHandler.bind(this)
          )),
        (this.cart =
            document.querySelector('cart-notification') ||
            document.querySelector('cart-drawer')),
        (this.submitButtons = this.querySelectorAll('[type="submit"]')),
        document.querySelector('cart-drawer') &&
            this.submitButtons.forEach((button) => button.setAttribute('aria-haspopup', 'dialog')),
        (this.hideErrors = 'true' === this.dataset.hideErrors);
      }
      async onSubmitHandler(e) {
        e.preventDefault();

        let gwp_sections;
  
        if (this.submitButtons.forEach(button => button.classList.contains('loading'))) return

        if (!this.form) {
          this.form = document.querySelector('form');
        }
        const formData = new FormData(this.form);

        let quantity = 1;
        if (this.querySelector('input[name="quantity"]')) {
          quantity = this.querySelector('input[name="quantity"]').value;
        }
        formData.append('quantity', quantity);

        if (this.quantitySpinner != null && this.cartUI != null) {
          formData.append('sections', this.cartUI.getSectionsToRender().map((section) => section.id).concat(this.quantitySpinner.getSectionsToRender().map((section) => section.id)))
          gwp_sections = this.cartUI.getSectionsToRender().map((section) => section.id).concat(this.quantitySpinner.getSectionsToRender().map((section) => section.id))
        } else if (this.quantitySelector != null && this.cartUI != null) {
          formData.append('sections', this.cartUI.getSectionsToRender().map((section) => section.id).concat(this.quantitySelector.getSectionsToRender().map((section) => section.id)))
          gwp_sections = this.cartUI.getSectionsToRender().map((section) => section.id).concat(this.quantitySelector.getSectionsToRender().map((section) => section.id))
        } else {
          formData.append('sections', this.cartUI ? this.cartUI.getSectionsToRender().map((section) => section.id) : [])
          gwp_sections = this.cartUI ? this.cartUI.getSectionsToRender().map((section) => section.id) : []
        }
        formData.append('sections_url', window.location.pathname)
        const gwp_sections_url = window.location.pathname

        if (
          (e.preventDefault(),
          'true' !== this.submitButtons.forEach(button => button.getAttribute('aria-disabled')))
        ) {
          this.submitButtons.forEach(button => button.setAttribute('aria-disabled', true)),
          this.submitButtons.forEach(button => button.classList.add('loading')),
          this.querySelectorAll('.loading-overlay__spinner') && this.querySelectorAll('.loading-overlay__spinner').forEach(e => e.classList.remove('hidden'));
          let config = fetchConfig('javascript');
          (config.headers['X-Requested-With'] = 'XMLHttpRequest'),
          delete config.headers['Content-Type'];
          formData || formData.append('id', this.querySelector('[name=id]').value),
          this.cart &&
              (formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              ),
              formData.append('sections_url', window.location.pathname),
              this.cart.setActiveElement(document.activeElement)),
          (config.body = formData),
          fetch('' + routes.cart_add_url, config)
            .then((data) => data.json())
            .then(async (parsedState) => {
              if (parsedState.status) {
                this.has_cart_error = true;
                if (parsedState.status === 422) {
                  const component_ref = formData.get('component_ref')
                  this.has_cart_error = true;
                  const product_data = {
                    id: formData.get('product_id'),
                    component_ids: component_ref ? component_ref.split(',') : null
                  };
                  this.handlePurchaseLimitErrors(product_data, parsedState);
                }
              } else {
                let modal;
                this.cart
                  ? (this.has_cart_error ||
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                          source: 'product-form',
                          productVariantId: formData.get('id'),
                        }),
                  (this.has_cart_error = false),
                  (modal = this.closest('quick-add-modal'))
                    ? (document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          this.cart.renderContents(parsedState);
                        });
                      },
                      { once: true }
                    ),
                    modal.hide(true))
                    : this.cart.renderContents(parsedState))
                  : (window.location = window.routes.cart_url);
              }
            })
            .catch((errors) => {
              console.error('errors', errors);
              
              const error_message_html = `<ul>${errors.map(errorArr => {
                let errorMessage;

                if (this.isJson(errorArr)) {
                  errorMessage = JSON.parse(errorArr)[0]?.error;
                } else {
                  errorMessage = errorArr;
                }

                return `<li>${errorMessage}</li>`;
              }).join('')}</ul>`;
              this.handleErrorMessage(error_message_html);
              // This will scroll after submit when there are errors
              if (document.querySelector('.product-form__sticky-cta')) {
                const productButtons = document.querySelector('.product-form__buttons');
                const yCoordinate = (productButtons.getBoundingClientRect().top + window.pageYOffset) - (window.innerHeight / 2 + productButtons.getBoundingClientRect().height / 2)
                window.scrollTo({
                  top: yCoordinate,
                  behavior: 'smooth'
                });
              }
            })
            .finally(() => {
              if (!this.has_cart_error) {
                this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
                this.errorMessageWrapper.hidden = true
                this.submitButtons.forEach(button => button.classList.remove('loading')),
                this.cart &&
                      this.cart.classList.contains('is-empty') &&
                      this.cart.classList.remove('is-empty'),
                this.querySelectorAll('.loading-overlay__spinner') && this.querySelectorAll('.loading-overlay__spinner').forEach(e => e.classList.add('hidden'));
                this.fetchCart();
                if (this.umgGwp !== undefined) {
                  // Don't call umg gift with purchase if no gift with purchase data exists
                  UmgGwp(this.cartUI, gwp_sections, gwp_sections_url)
                }
                this.submitButtons.forEach(button => button.classList.remove('loading')),
                this.submitButtons.forEach(button => button.removeAttribute('disabled'))
              }
              this.submitButtons.forEach(button => button.removeAttribute('aria-disabled'))

              if (document.querySelector('add-all')){
                document.querySelectorAll('add-all').forEach(addAll => {
                  addAll.renderForm()
                })
              }
            });
        }
      }

      async fetchCart () {
        const response = await fetch('/cart.js')
        const data = await response.json()
        return data
      }

      isJson(item) {
        let value = typeof item !== "string" ? JSON.stringify(item) : item;    
        try {
          value = JSON.parse(value);
        } catch (e) {
          return false;
        }
        return typeof value === "object" && value !== null;
      }

      handleErrorMessage(errorMessage = false) {
        const submitButtons = this.querySelectorAll('[type="submit"]')
        submitButtons.forEach(button => button.classList.remove('loading'))
        submitButtons.forEach(button => button.removeAttribute('disabled'))
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
        if (!this.errorMessageWrapper) return
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')
        this.errorMessageWrapper.removeAttribute('hidden')
        if (errorMessage) {
          this.errorMessage.innerHTML = errorMessage
        } else {
          this.errorMessage.textContent = window.cartStrings.error
        }
      }
      /**
       * The function handles purchase limit errors by filtering and throwing the relevant errors.
       * @param product - The `product` parameter is an object that represents a product. It contains
       * properties such as `type`, `component_ids`, `id`, etc.
       * @param parsedState - parsedState is an object that contains information about the state of the
       * Ajax API response. It may have properties like "errors" or "message" which contain error information.
       */

      handlePurchaseLimitErrors (product, parsedState) {
        const filtered_errors = []
        const errors = parsedState.errors ? parsedState.errors : parsedState.message
        const is_json_response = this.isJson(errors)

        if (is_json_response) {
          // Purchase Limits Errors
          const products_with_errors = JSON.parse(errors)
          let product_ids = []

          if (product.component_ids) {
            product_ids = [...product.component_ids]
          } else {
            product_ids.push(product.id)
          }
          products_with_errors.forEach(product => {
            if (product_ids.includes(product.id)) {
              if (product.productLevelLimit !== null && product.error !== '') {
                filtered_errors.push(product.error)
              } else if (product.variants.length) {
                product.variants.forEach(variant => {
                  if (variant.maxVariantLimit !== null) {
                    if (variant.error !== '') {
                      filtered_errors.push(variant.error)
                    }
                  }
                })
              }
            }
          })
        } else {
          // Standard shopify cart errors
          filtered_errors.push(parsedState.errors ? parsedState.errors : parsedState.description)
        }

        throw filtered_errors;
      }

      handleStickyAtc () {
        const stickyAtcWrappers = document.querySelectorAll('.product-form__submit-wrapper-sticky');

        if (stickyAtcWrappers.length < 1) { // Ensure stickyAtcWrapper element exists
          return;
        }

        // Hide stickyAtcWrapper if its ancestor has class name 'quick-add-modal'
        stickyAtcWrappers.forEach(e => {
          const stickyAtcBtn = e.querySelector('.product-form__sticky-cta');
          if (stickyAtcBtn.getAttribute('form').includes('product-form-quickadd-template')) {
            e.style.display = 'none';
          }
        });

        if (!document.body.classList.contains('template-product')) {
          stickyAtcWrappers.forEach(e => e.style.display = 'none');
          return;
        } else {
          document.addEventListener('DOMContentLoaded', function () {
            const headerElements = document.querySelectorAll('.shopify-section-group-header-group');
            const footerElements = document.querySelector('.shopify-section-group-footer-group');
            const buttonHeight = document.querySelector('.main-product .product-form__submit').offsetHeight;
            const staticAtc = document.querySelector('.product-form__buttons .product-form__submit-wrapper');
            const playPauseBtn = document.querySelector('.global-video-control');
            let headerTotalHeight = buttonHeight / 2; // Show sticky header around halfway 

            headerElements && headerElements.forEach(element => headerTotalHeight += element.offsetHeight);

            const observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    playPauseBtn.style.transform = `translateX(0) translateY(0)`;
                    stickyAtcWrappers.forEach(e => e.style.transform = `translateX(0) translateY(100%)`);
                    footerElements.style.marginBottom = `${buttonHeight}px`;
                  } else {
                    playPauseBtn.style.transform = `translateX(0) translateY(-${buttonHeight}px)`;
                    stickyAtcWrappers.forEach(e => e.style.transform = `translateX(0) translateY(0)`);
                  }
                });
              },
              {
                rootMargin: headerElements ? `-${headerTotalHeight}px 0px 0px 0px` : '0px',
                threshold: 0
              }
            );

            if (window.innerWidth < 1199) {
              observer.observe(staticAtc);
            }

            const resizeObserver = new ResizeObserver(entries => {
              for (let entry of entries) {
                const width = entry.contentRect.width;

                if (width > 1199) {
                  playPauseBtn.style.transform = `translateX(0) translateY(0)`;
                } else {
                  observer.observe(staticAtc);
                }
                
              }
            });

            resizeObserver.observe(document.documentElement);
          });
        }
      }

      // TODO: Add ability to click sticky CTA to scroll variant selector into view

      // stickyAtcAnchor () {
      //   const stickyAtcBtn = document.querySelector('.product-form__sticky-cta');

      //   if (!stickyAtcBtn.disabled) {
      //     return;
      //   }
        
      //   const productInfo = document.querySelector('.main-product .product__title__wrapper');

      //   if (document.querySelector('.main-product .product-form__submit-wrapper-sticky').querySelector('span').innerText.toLowerCase() !== 'add to cart'){
      //     stickyAtcBtn.addEventListener('click', (e) => {
      //       productInfo.scrollIntoView({ behavior: 'smooth'});
      //     });
      //   }
      // }
    }
  );